module.exports = __webpack_public_path__ + "media/images/flags/4x3/atg-cd5f7986d91be9d936c3ec07529be1f4.svg";